import { AxiosResponse } from 'axios';

import { LandlordBooking } from '../../types/bookings';
import { PaginatedResponse } from '../../types/utils';
import httpRequest from '../httpRequest';

const baseURL = process.env.REACT_APP_GW_API_URL;

const bookingsAPI = {
  getLandlordBookings: async ({
    bookingsStatusFilters,
    page,
    per_page,
  }: {
    bookingsStatusFilters: string;
    page: number;
    per_page: number;
  }) => {
    const { data } = await httpRequest<
      PaginatedResponse<Array<LandlordBooking>>
    >({
      baseURL: baseURL,
      url: `/dalgona/landlord/bookings/`,
      method: 'GET',
      params: {
        p: { page, per_page },
        ...(bookingsStatusFilters && { f: { status: bookingsStatusFilters } }),
      },
    });

    return data;
  },

  acceptLandLordBooking: async ({ bookingId }: { bookingId: string }) => {
    const { status } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/landlord/bookings/${bookingId}/accept`,
      method: 'POST',
    })) as AxiosResponse;
    return status;
  },

  counterOfferLandlordBooking: async ({
    bookingId,
    counter_offer,
    from_date,
    message_for_tenant,
  }: {
    bookingId: string;
    counter_offer: number;
    from_date: string;
    message_for_tenant: string;
  }) => {
    const { status } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/landlord/bookings/${bookingId}/counter-offers`,
      data: {
        counter_offer,
        from_date,
        message_for_tenant,
      },
      method: 'POST',
    })) as AxiosResponse;
    return status;
  },

  rejectLandLordBooking: async (bookingId: string) => {
    const { status } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/landlord/bookings/${bookingId}/reject`,
      method: 'POST',
    })) as AxiosResponse;
    return status;
  },

  getTenantBookings: async ({
    bookingsStatusFilters,
    page,
    per_page,
  }: {
    bookingsStatusFilters: string;
    page: number;
    per_page: number;
  }) => {
    const { data } = await httpRequest<
      PaginatedResponse<Array<LandlordBooking>>
    >({
      baseURL: baseURL,
      url: `/dalgona/tenant/bookings/`,
      method: 'GET',
      params: {
        p: { page, per_page },
        ...(bookingsStatusFilters && { f: { status: bookingsStatusFilters } }),
      },
    });

    return data;
  },

  acceptTenantCounterOffer: async (bookingId: string) => {
    const { status } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/tenant/bookings/${bookingId}/counter-offer/accept`,
      method: 'POST',
    })) as AxiosResponse;
    return status;
  },

  rejectTenantCounterOffer: async (bookingId: string) => {
    const { status } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/tenant/bookings/${bookingId}/counter-offer/reject`,
      method: 'POST',
    })) as AxiosResponse;
    return status;
  },
};

export default bookingsAPI;
